import { styled } from 'css-literal-loader/styled';
import defaultProps from 'recompose/defaultProps';

const Text = defaultProps({ display: 'block' })(
  styled('span', null, "Text", require("./Text-Text.module.scss"), "text", "text"),
);

export default Text;
